export default __webpack_public_path__ + "static/media/toggle.573dbb96.svg";